"use client"

import type { ReactNode } from "react"

import { Skeleton } from "@/components/ui/skeleton"

export function MatchCardSkeleton() {
  return (
    <div
      className="flex w-full flex-col overflow-hidden rounded-[8px] bg-[var(--rtbf-blue-dark,#003E63)] shadow-[0px_5px_15px_0px_rgba(0,0,0,0.10)]"
      aria-hidden
    >
      <div className="bg-[var(--rtbf-blue,#0076A9)] px-4 py-5">
        <Skeleton className="mx-auto h-4 w-24 bg-white/20" />
      </div>
      <div className="flex flex-col gap-3 px-4 py-4">
        <div className="flex items-center justify-between gap-3">
          <Skeleton className="h-10 w-10 shrink-0 rounded-full bg-white/10" />
          <Skeleton className="h-8 w-12 rounded-[8px] bg-white/10" />
          <Skeleton className="h-10 w-10 shrink-0 rounded-full bg-white/10" />
        </div>
        <div className="flex items-center justify-center gap-2">
          <Skeleton className="h-10 w-14 rounded-[8px] bg-white/10" />
          <Skeleton className="h-10 w-8 rounded-[8px] bg-white/10" />
          <Skeleton className="h-10 w-14 rounded-[8px] bg-white/10" />
        </div>
      </div>
      <div className="mt-auto border-t border-[var(--rtbf-blue,#0076A9)] px-4 py-3">
        <Skeleton className="h-10 w-full rounded-[8px] bg-white/10" />
      </div>
    </div>
  )
}

function PointsOverviewSkeleton() {
  return (
    <div className="flex items-center justify-center" aria-hidden>
      <div className="flex items-center">
        <div className="flex h-[96px] flex-col items-center justify-center px-4">
          <Skeleton className="h-[72px] w-[72px] rounded-[4px] bg-[var(--rtbf-orange,#fdc300)]/40" />
        </div>
        <div className="flex w-[185px] flex-col gap-1">
          <Skeleton className="h-[21px] w-full rounded-[4px] bg-white/20" />
          <Skeleton className="h-[21px] w-full rounded-[4px] bg-white/15" />
          <Skeleton className="h-[21px] w-full rounded-[4px] bg-white/20" />
        </div>
      </div>
    </div>
  )
}

type PredictionsPageSkeletonProps = {
  weekSwitch: ReactNode
  showPointsOverview?: boolean
}

export function PredictionsPageSkeleton({
  weekSwitch,
  showPointsOverview = false,
}: PredictionsPageSkeletonProps) {
  return (
    <div
      className="min-h-screen bg-[var(--rtbf-dark,#001425)] pb-20 pt-6 px-3 sm:px-4"
      aria-busy="true"
      aria-label="Chargement des pronostics"
    >
      <div className="relative mx-auto max-w-6xl overflow-hidden rounded-2xl bg-black">
        {weekSwitch}
      </div>

      {showPointsOverview && (
        <div className="mx-auto mt-4 max-w-6xl">
          <PointsOverviewSkeleton />
        </div>
      )}

      <div className="mx-auto mt-4 grid max-w-6xl grid-cols-1 gap-4 md:mt-6 md:grid-cols-2 md:gap-6 xl:grid-cols-3">
        <div className="col-span-full">
          <Skeleton className="h-6 w-40 bg-white/20" />
        </div>
        {Array.from({ length: 6 }).map((_, index) => (
          <MatchCardSkeleton key={index} />
        ))}
      </div>
    </div>
  )
}
